import { mapMutations, mapGetters, mapActions } from "vuex";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "change-password-form",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                password: "",
                new_password: "",
                new_password_confirmation: "",
            },
            isEditOldPassword: false,
            isEditNewPassword: false,
            nextStep: false,
            validationErrors: {},
        };
    },
    validations() {
        return {
            payload: {
                password: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                },
                new_password: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                },
                new_password_confirmation: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                    sameAsPassword: sameAs("new_password"),
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            isEditProfileData: "profile/editProfileData",
            user: "profile/user",
        }),
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 8));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        newPasswordErrors() {
            let error = [];
            if (!this.$v.payload.new_password.$dirty) {
                return error;
            }
            if (!this.$v.payload.new_password.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.new_password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.new_password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 8));
            }
            if (this.validationErrors.new_password) {
                this.validationErrors.new_password.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        newPasswordConfirmationErrors() {
            let error = [];
            if (!this.$v.payload.new_password_confirmation.$dirty) {
                return error;
            }
            if (!this.$v.payload.new_password_confirmation.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.new_password_confirmation.sameAsPassword) {
                error.push(this.$t("validationSameAs"));
            }
            if (this.validationErrors.new_password_confirmation) {
                this.validationErrors.new_password_confirmation.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButtonOldPassword() {
            if (this.payload.password === "" && this.payload.password_confirmation === "") {
                return true;
            }
        },
    },
    methods: {
        ...mapActions({
            updateUserPassword: `profile/UPDATE_USER_PASSWORD`,
        }),
        ...mapMutations({
            changeEditProfileData: `profile/CHANGE_EDIT_PROFILE_DATA`,
        }),
        cancelOldPassword() {
            this.payload.password = "";
            this.payload.new_password = "";
            this.payload.new_password_confirmation = "";
            this.isEditOldPassword = false;
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        clearInputs() {
            this.payload.password = "";
            this.payload.new_password = "";
            this.payload.new_password_confirmation = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.updateUserPassword(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t("successChangePassword"));
                        this.isEditOldPassword = false;
                        this.clearInputs();
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.$toasted.error(this.$t("failChangePassword"));
                            this.validationErrors = error.response.data.errors;
                        }
                    });
            }
        },
    },
};
